export default __webpack_public_path__ + "static/case-3-name-33943c116d047e8be1d39a08968d4e2f.png";